import AxiosJob from '@/services/api/job/axios_job'

export default {
  createJobDefinition: (data) => {
    return AxiosJob.post('job-definition', data)
  },

  updateJobDefinition: (jobDefinitionId, data) => {
    return AxiosJob.put(`job-definition/${jobDefinitionId}`, data)
  },

  getAllJobDefinitions: (params) => {
    return AxiosJob.get('job-definition', { params })
  },

  getJobDefinition: (jobDefinitionId) => {
    return AxiosJob.get(`job-definition/${jobDefinitionId}`)
  },

  deleteJobDefinition: (jobDefinitionId) => {
    return AxiosJob.delete(`job-definition/${jobDefinitionId}`)
  }
}
